
import React, {Component} from 'react';
import {FormControl,Button,ButtonToolbar} from 'react-bootstrap'
import Select from 'react-select'
import FontAwesome from 'react-fontawesome'
import AutopartStore from '../../stores/AutopartStore'
// import SWTStockPartItemEditModal from './SWTStockPartItemEditModal'


class SWTExPartItemList extends Component {

  constructor(...args){
    super(...args)
    this.state = {refreshOption:false,loading:false,activeTab:"1",showEdit:false,query:'',catOptions:[],tableData:[]}

    this.openPopup() 
  }

  openPopup(){
    this.setState({loading:true})
    let that = this
    AutopartStore.loadExPartCategory(function(result){
      let options = result.data.map((item,index)=>{
        return {label:item.name,value:item.cat_id}
      })
      that.setState({loading:false,catOptions:options})

      that.loadExPartItemList('-1')
    })

    
    
  }

  loadExPartItemList(categoryId,query){
    let that = this
    AutopartStore.loadExPartItemList(categoryId,query,function(result){
      that.setState({tableData:result.data,loading:false})
    })
  }

  onRefreshOptions(){
    this.openPopup()
  }

  onHide(){

  }

  onSelectChange(value){
    // let {catSelect} = this.state
    if(value!==null)
      this.loadExPartItemList(value.value);
    else
      this.loadExPartItemList(-1);
    this.setState({catSelect:value,loading:true})
  }

  onSelectOpen(){
    let {refreshOption} = this.state
    if(refreshOption){
      this.openPopup()
      this.setState({refreshOption:false})
    }
  }

  onTextChange(e){
    let {catSelect} = this.state
    let query = e.target.value

    if(typeof query!=='undefined' && query.length>2){
      if(typeof catSelect!=='undefined' &&catSelect!==null){
        this.loadExPartItemList(catSelect.value,query);
      }else{
        this.loadExPartItemList(-1,query);
      }
      this.setState({loading:true})
    }
    this.setState({query:query})
    
  }

  onNewClick(){
    //this.refs.wageitemedit.loadItemcode(null)
    //this.setState({showEdit:true})
    //window.request_newstockpart();
    this.setState({refreshOption:true})
  }

  onEditClick(item){
    //this.refs.wageitemedit.loadItemcode(item)
    //this.setState({showEdit:true})
    //window.request_editstockpart(item.itemnum);

  }

  onRowClick(item){
    
    this.props.onRowClick(Object.assign(item,{price_per_unit:''}))
        
  }

  onActiveTab(activeTab){
    this.setState({activeTab:activeTab})
  }

  onClearClick(){
    this.setState({query:'',catSelect:null})
    this.loadExPartItemList('-1')
  }

  onAfterSubmit(){

  }

  renderSearch(){
    let {query,catSelect,catOptions} = this.state
    return (
      <div className='row form-group'>
        <div className='col-md-3'>
          <Select value={catSelect} placeholder={'เลือกหมวดหมู่'} options={catOptions} 
          onOpen={this.onSelectOpen.bind(this)}
          onChange={this.onSelectChange.bind(this)}/>
        </div> 
        <div className='col-md-8' style={{display:'inline-flex'}}>
          <FormControl value={query} onChange={this.onTextChange.bind(this)}/>
          <ButtonToolbar style={{width:'440px',marginLeft:'10px'}}>
            <Button onClick={this.onClearClick.bind(this)}><FontAwesome name="eraser"/>&nbsp;ลบการค้นหา</Button>
            <Button bsStyle={'primary'} onClick={this.onNewClick.bind(this)}><FontAwesome name="plus"/>&nbsp;เพิ่มรายการค่าอะไหล่</Button>
          </ButtonToolbar>
        </div> 

      </div>
    )
  }

  renderExPartSearch(){
    let {query,catSelect,catOptions} = this.state
    return (
      <div className='row form-group'>
        <div className='col-md-3'>
          <Select value={catSelect} placeholder={'เลือกหมวดหมู่'} options={catOptions} 
          onOpen={this.onSelectOpen.bind(this)}
          onChange={this.onSelectChange.bind(this)}/>
        </div> 
        <div className='col-md-8' style={{display:'inline-flex'}}>
          <FormControl value={query} onChange={this.onTextChange.bind(this)}/>
          <ButtonToolbar style={{width:'440px',marginLeft:'10px'}}>
            <Button onClick={this.onClearClick.bind(this)}><FontAwesome name="eraser"/>&nbsp;ลบการค้นหา</Button>
            <Button bsStyle={'primary'} onClick={this.onNewClick.bind(this)}><FontAwesome name="plus"/>&nbsp;เพิ่มรายการค่าอะไหล่</Button>
          </ButtonToolbar>
        </div> 

      </div>
    )
  }

  renderRowData(){
    let {tableData} = this.state
    return tableData.map((item,index)=>(
      <tr key={index}>
        <td  onClick={this.onRowClick.bind(this,item)}>{item.itemnum}</td>
        <td  onClick={this.onRowClick.bind(this,item)}>{item.cat_name}</td>
        <td  onClick={this.onRowClick.bind(this,item)}>{item.productcode}</td>
        <td  onClick={this.onRowClick.bind(this,item)}>{item.description}</td>
        <td className='text-center'><Button onClick={this.onEditClick.bind(this,item)}>แก้ไข</Button></td>
      </tr>
    )) 
  }

  renderSearchResult(){
    return (
      <table className='table table-responsive table-hover table-bordered-solid'>
        <thead>
          <tr>
            <th>#ID</th>
            <th>หมวดหมู่</th>
            <th>รหัสสินค้า</th>            
            <th>รายการ</th>                        
            <th>แก้ไข</th>
          </tr>
        </thead>
        <tbody>
          {this.renderRowData()}
        </tbody>
        
      </table>
    )
  }

  

  render(){
    let {loading} = this.state
    return (
      <div className='box' >
        <div className='box-body'>
          {this.renderSearch()}
          {this.renderSearchResult()}
        </div>
        <div className="overlay" style={{display:(loading?'block':'none')}}>
          <i className="fa fa-refresh fa-spin"></i>
        </div>
      </div>
    )
  }


  

}


export default SWTExPartItemList;





// WEBPACK FOOTER //
// ./src/view/workdoc/SWTExPartItemList.js